<template>
  <div>
    <b-row>
      <b-col>
        <GmapAutocomplete
          @place_changed="placechange1"
          class="mt-1 location-search"
          :options="{
            fields: ['geometry', 'formatted_address', 'address_components']
          }"
        ></GmapAutocomplete>
      </b-col>
    </b-row>
    <div class="streetmargintop">
      <b-row>
        <b-col md="12">
          <c-input
            type="text"
            inputId="state"
            readonly
            v-model="office.address.country"
            lableText="Country"
          />
        </b-col>
      </b-row>
      <b-row class="statemargintop">
        <b-col md="6">
          <c-input
            type="text"
            inputId="state"
            readonly
            v-model="office.address.state"
            lableText="State"
          />
        </b-col>

        <b-col md="6">
          <c-input
            type="text"
            inputId="city"
            readonly
            v-model="office.address.city"
            lableText="City"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="zipcode"
          >
            <c-input
              inputType="number"
              inputId="zipcode"
              v-model="office.address.zip"
              lableText="Zipcode"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <br />
      <br />
      <slot name="footer-button" :data="office">
        <b-button
          class="btn btn-block mt-3"
          btn-color="primary"
          @click="e => $emit('onClickOffice', office)"
          >Next</b-button
        >
      </slot>
    </div>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import csc from "country-state-city";
import ebSelect from "@/components/FormElements/Select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import locationMixins from "@/mixins/addressLocation";

export default {
  name: "AddressStepper",
  mixins: [locationMixins],
  data() {
    return {
      countries: [],
      states: [],
      cities: [],
      tenant: null,
      office: {
        address: {
          country: "",
          area: "",
          state: "",
          city: "",
          street1: "",
          street2: "",
          zip: "",
          houseNumber: "",
          location: {
            coordinates: [0, 0]
          }
        }
      }
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    cInput,
    cTelInput,
    ebSelect
  },
  methods: {
    placechange1(e) {
      this.placechange(e);
      this.$emit("place_changed", e);
      let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
      console.log("mapdata", mapdata);
      if (mapdata) {
        console.log("mapdata1", mapdata);

        this.office.address.country = mapdata.data.Country;
        this.office.address.city = mapdata.data.City;
        this.office.address.state = mapdata.data.State;
        this.office.address.area = mapdata.data.Area ? mapdata.data.Area : "";
        this.office.address.zip = mapdata.data.zip ? mapdata.data.zip : "";
        this.office.address.location = {
          coordinates: [mapdata.Lng, mapdata.Lat]
        };
      }
    },
    isValidate(e, p) {
      p.country = { ...e.country };
      p.isValid = e.isValid;
    },
    getCountry(payload) {
      this.setState(payload.id);
      this.office.address.country = payload.name;
    },
    getState(payload) {
      this.setCity(payload.id);
      this.office.address.state = payload.name;
    },
    getCity(payload) {
      this.office.address.city = payload.name;
    },
    async setCountry() {
      this.countries = await csc.getAllCountries();
    },
    async setState(id) {
      this.states = await csc.getStatesOfCountry(id);
    },
    async setCity(id) {
      this.cities = await csc.getCitiesOfState(id);
    }
  },
  mounted() {
    this.setCountry();
  }
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: 'Lato';
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 39px;
  width: 132px;
  background-color: #727cf5;
  color: white;
}
.statemargintop {
  margin-top: -15px !important;
}
.streetmargintop {
  margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
  border-radius: 0px !important;
  height: 39px !important;
  border: 1px solid #dee2e6 !important;
}
</style>
